/***
* Add by jfzhu
* created:20190805
* 注:商家联盟拓客首页
*/
<template>
  <div>
    <div class="MerOrderList">
      <div class="item-div" v-for="(item,index) in orderList" :key="index">
        <div class="top">
          <div class="t_l">
            <img src="../../resource/img/icon_time@2x.png"/>
            <span>{{ item.orderTime }}</span>
          </div>
          <span class="status-text" v-if="item.paid == 0">待支付</span>
          <span class="status-text" v-if="item.paid == 1 && item.status == 0">待服务</span>
          <span class="status-text" v-if="item.paid == 1 && item.status == 1">已完成</span>
        </div>
        <div class="orderinfo">
          <img :src="imageUrl + item.pic"/>
          <div class="ordertitle">
            <span>{{ item.activityName }}</span><br/>
            <span>商品价格：{{ item.totalMoney }}元</span>
          </div>
        </div>
        <div class="total">
          <span>合计：￥{{ item.totalMoney }}</span>
        </div>
        <div class="menus">
          <template v-if="item.paid==0">
            <div class="delmenu" @click="delOrder(item.id)">删除订单</div>
            <div class="paymenu" @click="pay(item)">支付</div>
          </template>
          <div v-if="item.paid == 1" class="delmenu" @click="detail(item)">查看详情</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MerOrderList',
  data () {
    return {
      data: {},
      orderList: [],
      // imageUrl: sessionStorage.url,
      imageUrl: 'https://files.mbspt.com'
    }
  },
  created () {
    this.$common.changetitle('订单列表')
    this.data = this.$route.query
    this.getOrderData()
  },
  methods: {
    getOrderData () {
      this.$api.post({
        url: '/merchant/api/merchant/merchant-union-order/list',
        data: {
          activityId: this.data.activityId,
          uid: this.data.uid
        },
        login: false
      }).then(res => {
        this.orderList = res.data
      })
    },
    pay (item) {
      this.$axios.post('/merchant/api/activity/merchant-union-market-extend/pay', this.$qs.stringify({
        merId: item.merId,
        out_trade_no: item.orderId,
        body: item.activityName,
        total_fee: item.totalMoney,
        uid: item.uid,
        activityId: item.activityId,
        openid: this.$common.userinfo.openid //ceshi
      })).then(response => (
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            'appId': response.data.data.appid,
            'timeStamp': response.data.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            'nonceStr': response.data.data.nonceStr, // 支付签名随机串，不长于 32 位
            'package': response.data.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            'signType': response.data.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            'paySign': response.data.data.sign, // 支付签名
          },
          function (res) {
            if (res.err_msg == 'get_brand_wcpay_request:ok') {
              location.reload()
            } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
              alert('你已经取消订单支付')
            } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
              alert('订单交易失败')
            }
          })
      )).catch(function (error) {
        console.log(error)
      })
    },
    //跳转订单详情
    detail (item) {
      this.$router.push({
        path: '/MerUnionOrderDetail',
        query: {
          activityId: item.activityId,
          uid: item.uid,
          orderId: item.orderId
        }
      })
    },
    //删除订单
    delOrder (id) {
      if (confirm('确认删除吗？')) {
        this.$api.post({
          url: '/merchant/api/merchant/merchant-union-order/del',
          data: {
            id: id,
          },
          login: false
        }).then(res => {
          this.getOrderData()
        })
      }
    }
  },


}
</script>

<style scoped>
.MerOrderList {
  padding: 50px 3vw 0 3vw;
  font-size: 15px;
}

.item-div {
  background-color: #fff;
  margin-top: 10px;
  padding: 10px;
  border-radius: 10px;
}

.top {
  height: 5vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top .status-text {
  color: #F1BE36;
}

.t_l {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
}

.t_l > div {
  line-height: 70px;
  float: left;
}

.t_l > img {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}

.orderinfo {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
}

.orderinfo > img {
  width: 90px;
  height: 90px;
  border-radius: 10px;
  margin-right: 10px;
}

.ordertitle {
  display: flex;
  flex-direction: column;
  color: #9B9B9B;
}

.ordertitle > span {
  font-weight: 400;
  color: #000;
}

.total {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 35px;
  border-bottom: 1px solid #9B9B9B;
  line-height: 35px;
  background-color: #fff;
}

.menus {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: 60px;
  background-color: #fff;
}

.paymenu, .delmenu {
  height: 28px;
  line-height: 28px;
  border-radius: 30px;
  border: 2px solid #9B9B9B;
  padding: 0px 20px;
  margin-left: 20px;
}

.paymenu {
  border: 2px solid #F5A623;
}


</style>



// WEBPACK FOOTER //
// src/components/active/MerUnionOrderList.vue